import {
    FETCH_REPORT, 
    RESET_STATE, 
    SAVE_REPORT, 
    CUSTOM_REPORT_FETCH_CHART,
    CUSTOM_REPORT_SAVE_BOT_STATUS,
    CUSTOM_REPORT_SAVE_BOT_CHARTS,
    CUSTOM_REPORT_CREATE_BOT,
    FETCH_JOURNEY_REPORT_METADATA,
    SAVE_JOURNEY_REPORT_METADATA
} from "../constants/dashboard";

export const getReports = (type, subtype, query, callback) => {
    return {
        type: FETCH_REPORT,
        payload: { type, subtype, query, callback }
    }
}

export const saveReport = (type, subtype, data) => {
    return {
        type: SAVE_REPORT,
        payload: { type, subtype, data}
    }
}
export const resetDashboardState = () => {
    return {
        type: RESET_STATE,

    }
}

export const customReportFetchChart = () => {
    return {
        type: CUSTOM_REPORT_FETCH_CHART
    }
}

export const customReportSaveBotStatus = (status) => {
    return {
        type: CUSTOM_REPORT_SAVE_BOT_STATUS,
        payload: status
    }
}

export const customReportSaveBotCharts = (reports) => {
    return {
        type: CUSTOM_REPORT_SAVE_BOT_CHARTS,
        payload: reports
    }
}

export const customReportCreateBot = () => {
    return {
        type: CUSTOM_REPORT_CREATE_BOT
    }
}

export const fetchJourneyReportMetadata = () => {
    return {
        type: FETCH_JOURNEY_REPORT_METADATA
    }
}

export const saveJourneyReportMetadata = (data) => {
    return {
        type: SAVE_JOURNEY_REPORT_METADATA,
        payload: data
    }
}
